<template>
 <!-- D: c-tab-panel과 c-tab-panel-wrap은 세트임 -->
  <!-- D: border가 없는경우 type-non-border 추가 -->
  <div class="c-tab-panel-wrap type-non-border">
    <!-- tab content: tab1 -->
    <div class="tab-panel" role="tabpanel" aria-labelledby="tab1-1">
      <div class="mixing-search-wrap">


        <div>
          <strong class="find-color-box-title">검색방법</strong>
          <div class="find-color-box-desc">
            <div>
              소수점 단위의 먼셀 기호 전체를 입력하여 검색하는 방법(예시: 1.3PB 5.4/5.0)<br>
              <span style="color: #505050;">※ 영문 뒷자리는 반드시 한칸을 띄우신 후 입력하세요.</span><br>
            </div>
            <div style="margin-top: 6px;">
              칼라코드 일부분만을 입력하여 검색하는 방법 예시 : 1.3PB 또는 5.4/5.0<br>
              <span style="color: #505050;">※ 일부분의 기호를 포함한 전체 리스트가 나열되어 검색됩니다.</span>
            </div>
          </div>
        </div>


        <!-- D: 상세검색 -->

        <form action="form-wrap" style="margin-top:20px;" @submit.prevent="searchCmd('munsellSearch', {})">
          <div class="c-board-write find-board-write">
            <div class="tr">
              <div class="th">
                <div class="find-select type-medium type-medium-2">
                  <select name="" id="" v-model="data.colorCombin.search.searchType">
                    <option value="munsell">먼셀번호</option>
                    <option value="collar">칼라코드</option>
                  </select>
                </div>
                <div class="c-popover-detail" data-popover="delivery1" >
                  <div class="text" >배합 답변 DB 기반 검색</div>
                </div>
              </div>
              <div class="td">
                <!--
                  D.
                  1. data-layer-hidden 속성 존재시 단순 검색 케이스로 바뀜
                  2. data-search-ui는 뒤늦게 추가된 공통 검색 ui를 동작하기위한 속성
                -->
                <div class="c-filter-search" data-search-ui data-layer-hidden>
                  <div class="search-form">
                    <label class="sr-only">조색배합검색</label>
                    <input type="search" id="searchQuery" title="검색" class="search-input" autocomplete="off"
                      @keydown.enter="searchCmd('munsellSearch', {})"
                      v-model="data.colorCombin.search.searchKeyword"
                      placeholder="먼셀번호, 칼라코드 입력">
                    <button type="button" class="search-cancel" 
                            @click="resetCmd('keyword')">
                      <i class="c-icon icon-large-x"></i>
                      <span class="sr-only">검색어 재입력</span>
                    </button>
                    <button type="button" class="search-submit" 
                            @click="searchCmd('munsellSearch', {})">
                      <span class="sr-only">검색</span>
                    </button>
                  </div>
                  <!-- search layer -->
                  <div class="search-layer">
                    <div class="search-layer-inner">
                      <div class="keydown-result">
                        <ul class="search-result-list">
                          <li class="search-result-item">
                            <a href="javascript:void(0);" class="result">건축
                              <span class="color-primary">수성</span>
                            </a>
                          </li>
                          <li class="search-result-item">
                            <a href="javascript:void(0);" class="result">건축 내부<span
                                class="color-primary">수성</span>용</a>
                          </li>
                          <li class="search-result-item">
                            <a href="javascript:void(0);" class="result">건축
                              <span class="color-primary">수성</span>
                            </a>
                          </li>
                          <li class="search-result-item">
                            <a href="javascript:void(0);" class="result">건축 내부<span
                                class="color-primary">수성</span>용</a>
                          </li>
                          <li class="search-result-item">
                            <a href="javascript:void(0);" class="result">건축
                              <span class="color-primary">수성</span>
                            </a>
                          </li>
                          <li class="search-result-item">
                            <a href="javascript:void(0);" class="result">건축 내부<span
                                class="color-primary">수성</span>용</a>
                          </li>
                          <li class="search-result-item">
                            <a href="javascript:void(0);" class="result">건축
                              <span class="color-primary">수성</span>
                            </a>
                          </li>
                          <li class="search-result-item">
                            <a href="javascript:void(0);" class="result">건축 내부<span
                                class="color-primary">수성</span>용</a>
                          </li>
                        </ul>
                      </div>
                      <!-- D: 검색어가 없을 경우 -->
                      <div class="search-nodata">
                        <p class="text">검색 결과가 없습니다.</p>
                      </div>
                    </div>

                    <button type="button" class="search-layer-close">
                      <i class="c-icon icon-small-white-x"></i>
                      <span>닫기</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        <!-- // D: 상세검색 -->
        <!-- D: 상세 검색 버튼 -->
        <div class="c-btn-area has-mixing-submit">
          <button
            type="button"
            class="c-util-button type-line-black"
            @click="resetCmd('reset')"
          >
            <span>초기화</span>
          </button>
          <button
            type="button"
            class="c-util-button type-primary"
            @click="searchCmd('munsellSearch', {})"
          >
            <span>조회</span>
          </button>
        </div>
        <!-- // D: 상세 검색 버튼 -->

        <div class="find-color-box-title-wrap">
          <strong class="find-color-box-title">검색된 리스트</strong>
        </div>

        <div class="body">

          <div class="simple-update-wrap">
            <!-- D: PC 전용 -->
            <div class="scroll-x only-pc">
              <div class="scroll-x-inner">
                <div class="d-table" style="width:1102px;">
                  <table>
                    <colgroup>
                      <col style="width:25%;">
                      <col style="width:15%;">
                      <col style="width:35%;">
                      <col style="width:25%;">
                    </colgroup>
                    <thead>
                      <tr>
                        <th class="ac" scope="row">먼셀번호</th>
                        <th class="ac" scope="row">칼라코드</th>
                        <th class="ac" scope="row">칼라북 제작업체명</th>
                        <th class="ac" scope="row">구분</th>
                      </tr>
                    </thead>
                    <tbody>                      
                      <tr v-for="(item, idx) in data.colorCombin.list" :key="idx">
                          <td>{{ item.munsellNo }}</td>
                          <td class="ac">{{ item.uniqNo }}</td>
                          <td class="ac">{{ item.company }}</td>
                          <td class="ac">{{ item.gubun }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <!-- // D: PC 전용 -->




            <!-- D: MO 전용 -->
            <div class="mixing-update-wrap">
              <div class="mo-mixing-update-list only-mo">
                <ul>
                  <li class="item item-find" v-for="(item, idx) in data.colorCombin.list" :key="idx">
                      <p class="find-title">먼셀번호</p>
                      <span class="find-desc">{{ item.munsellNo }}</span>
                      <p class="find-title">칼라코드</p>
                      <span class="find-desc">{{ item.uniqNo }}</span>
                      <p class="find-title">칼라북 제작업체명</p>
                      <span class="find-desc">{{ item.company }}</span>
                        <p class="find-title">구분</p>
                      <span class="find-desc">{{ item.gubun }}</span>
                  </li>
                </ul>
              </div>
            </div>
            <!-- // D: MO 전용 -->
            
            <!-- D : pageing area -->
              <Pagination
                ref="paginationEl"
                v-if="!data.colorCombin.list || data.colorCombin.list.length > 0"
                :total-pages="data.colorCombin.totalPage"
                :per-page="data.colorCombin.limit"
                :show-select="true"
                :page-reload-flag="data.colorCombin.pageReloadFlag"
                @page-change="handlePageChange"
                @items-per-page-change="handleItemsPerPageChange"
              />
            <!-- // D : pageing area -->

          </div>




          <!-- D: no data -->
          <div v-if="data.colorCombin.list.length  <= 0"  class="c-no-data-box">
            <div class="icon-box">
              <i class="c-icon icon-nodata size-large"></i>
            </div>
            <p class="text">조회 결과가 없습니다.</p>
          </div>

          <div style="margin-top: 20px;">
            <strong class="find-color-box-title">검색 가능한 대상 목록</strong>


            <div class="find-color-box-gray">
              <ul>
                <li>1. DPI의 칼라북(전문가용) 1,160칼라 (2003년도판)</li>
                <li>2. DPI의 칼라북(일반용) 317칼라 (2003년도판)</li>
                <li>3. 노루페인트 애니칼라 (개정판 NR칼라북) 1,221칼라북(2007년도판)</li>
                <li>4. 노루페인트 커버올 칼라북(색견본 카다로그)</li>
                <li>5. 노루페인트 COVER ALL 애니칼라시스템(2019년도판)</li>
              </ul>
            </div>


            <div class="find-color-box-green">
              <ul>
                <li>1. 협동조합 D-Color (1992년도판)</li>
                <li>2. 협동조합 E-Color (1996년도판)</li>
                <li>3. 협동조합 F-Color (2001년도판)</li>
                <li>4. 협동조합 G-Color (2008년도판)</li>
                <li>5. 협동조합 H-Color (2012년판)</li>
                <li>6. 협동조합 i-Color (2014년도판)</li>
                <li>7. 협동조합 J-Color (2017년도판)</li>
              </ul>
            </div>

            <div class="find-color-box-gray">
              <ul>
                <li>1. 삼화페인트 (95년도판)</li>
                <li>2. 삼화페인트 (98년도판)</li>
                <li>3. 삼화페인트(2002년도판) - A칼라</li>
                <li>4. 삼화페인트 전문가용 894칼라북(2003년도판) - B칼라</li>
                <li>5. 삼화페인트 528 COLOR 북(2007년도판) - C칼라</li>
                <li>6. 삼화페인트 677 COLOR 북(2010년도판) - D칼라</li>
                <li>7. 삼화페인트 Professional 2010년 판 - E칼라</li>
                <li>8. 삼화페인트 NCS COLLECTION 950</li>
              </ul>
            </div>

            <div class="find-color-box-green">
              <ul>
                <li>1. 조광페인트 1,000칼라북 (2002년도판)</li>
                <li>2. 조광페인트 609칼라북(2011년도판)</li>
              </ul>
            </div>

            <div class="find-color-box-gray">
              <ul>
                <li>1. 벽산페인트 504칼라북 (2005년도판)</li>
              </ul>
            </div>

            <div class="find-color-box-green">
              <ul>
                <li>1. 건설화학 제비표 칼라북 (2000년도판)</li>
                <li>2. 건설화학 제비표 KCI COLOR CARD 1판 459칼라(2003년판)</li>
                <li>3. 건설화학 제비표 1,000칼라 OK칼라북 (2006년도판)</li>
                <li>4. 건설화학 제비표 KCI COLOR CARD 2판 491칼라 (2006년도판)</li>
                <li>5. 건설화학 제비표 KCI COLOR CARD 3판 609칼라(2012년도판)</li>
                <li>6. 제비스코(마스터컬러컬렉션 1,249칼라)(2017년도판)</li>
              </ul>
            </div>

            <div class="find-color-box-gray">
              <ul>
                <li>1. KCC 968 칼라북 (2000년도판)</li>
                <li>2. KCC 1,050칼라북 (2005년판)</li>
                <li>3. KCC 903칼라북(2011년도판)</li>
              </ul>
            </div>

            <div class="find-color-box-green">
              <ul>
                <li>1. 이화여자대학교 환경색채100색표집</li>
                <li>2. 공공디자인 색채표준가이드 (지식경제부 기술표준원)</li>
                <li>3. 농어촌환경색표집 (농림수산식품부)</li>
                <li>4. SK건설용 NCS번호, 노루페인트 신규발행코드</li>
                <li>5. 심의용색견본270 2008년 (지식경제부, 한국디자인진흥원, CFT 제작)</li>
              </ul>
            </div>

            <div class="find-color-box-gray">
              <ul>
                <li>1. 서울지역색50 (디자인서울총괄본부)</li>
                <li>2. 인천환경색표집</li>
                <li>3. 대전환경색표집</li>
                <li>4. 남양주시 도시표준색표집 2008년 A판</li>
                <li>5. 울산색표집</li>
              </ul>
            </div>

          </div>



        </div>
      </div>
      </div>
    </div>
</template>


<script setup name="coloCombinInqTab">
import {
  onMounted,
  reactive,
  inject,
  nextTick,
  onBeforeUnmount,
  ref,
} from "vue";
import { popoverTrigger } from "@/js/_ui";
import { useRoute } from "vue-router";
import { api } from "@/plugins/api";
import { throttle } from "lodash";
//import { useToast } from "@/components/paintpro/composables/useToast";
import * as cmUtil from "@/utils/cmUtil.js";
import Pagination from "@/components/paintpro/base/pagination.vue";


const { isMobile } = cmUtil.useDeviceType();
const url = inject("url_prefix");
const paginationEl = ref(null);
const route = useRoute();


/***********************
 * 데이타 모음
 **********************/
const data = reactive({
  page: {
    deviceType: isMobile.value ? "M" : "P",
  },
  // 제품명(수성, 유성) selectBox Lsit
  selectBox: {
    list: [{typeStatus : 'munsell', typeText : '먼셀번호'},{typeStatus : 'coller', typeText : '칼라코드'}],
  },
  // 전체문의,MY배합 탭
  tabType: true,
  //문의리스트
  colorCombin: {
    flag: false,
    expendIndex: -1, //아코디언 index
    list: [],
    page: 0, // 현재 페이지
    limit: 20, // 목록 조회 행수
    totalCount: 0,
    totalPage: 0,
    pageReloadFlag: 0,
    loading: false,
    //조회조건
    search: {
      searchType: "munsell",
      searchKeyword: null,
    },
    init_search: {
      pntSeCd: "", //수성,유성
      prdctSeCd: "", //제품구분(일반,팬톤)
      chcPrdctSn: null,
      searchType: "munsell",
      searchKeyword: null,
    },
    chkPrdct: {}, //선택한 제품
    chkDate: "",
    chkSpcfct: [], // 색상배합
    munsellList: [], // 먼셀번호, 색상코드 리스트
    popover: false,
    allStartDate: null,
  },
  route: {
    combnCrcolnQstnSn: 0,
  },
});

/**********************
 * 마운트
 *********************/
onMounted(async () => {
  pageInit(); // 초기셋팅
  popoverTrigger(); // 팝오버

  if (route.params.id) {
    data.route.combnCrcolnQstnSn = route.params.id;
    data.colorCombin.limit = 100;
    data.tabType = false;
    data.colorCombin.search.tabType = "my";
    await searchCmd("search");
    data.colorCombin.pageReloadFlag++;
    goToSelectedPost();
  } else {
    searchCmd("search");
  }
});

// 아코디언 열린 위치로 스크롤 이동
const goToSelectedPost = () => {
  nextTick(() => {
    const id = route.params.id || "";
    if (id) {
      const idEl = document.getElementById(`ID${id}`);
      let positionTop = idEl?.getBoundingClientRect().top || 0;
      if (positionTop > 100) {
        positionTop -= 95;
      }                                                             
      window.scroll({ top: positionTop });
    }
  });
};


/**********************
 * 리셋 모음
 *********************/
async function resetCmd(cmd = "") {
  if (cmd === "reset") {
    data.colorCombin.search = { ...data.colorCombin.init_search };
    data.colorCombin.chkDate = "ALL";
  } else if (cmd === "keyword") {
    data.colorCombin.search.searchKeyword = null;
  }
}
/**********************
 * 페이징 모음
 *********************/
function handlePageChange(page) {
  searchCmd("munsellSearch", { page: page });
}
function handleItemsPerPageChange(perPage) {
  data.colorCombin.limit = perPage;
  searchCmd("munsellSearch", {});
}


/**********************
 * 버튼 클릭 모음
 *********************/
async function btnCmd(cmd = "", params = {}) {
  // 조색배합 아코디언 활성화
  if (cmd === "expendClick") {
    //등록된 답변이 있는 경우(답변완료)
    if (params.ansRemarkCn != null) {
      if (data.colorCombin.expendIndex == params.index) {
        data.colorCombin.expendIndex = -1;
      } else {
        data.colorCombin.expendIndex = params.index;
      }
      // 아코디언 닫을때 기본 값으로 재 조회 및 radio checked
      data.colorCombin.chkSpcfct[params.index] = params.spcfctCd;

      // 규격 + 색상배합 조회
      const resSpcfct = await api.post(`${url}/colorCombin/selectBox03`, {
        pntSn: params.pntSn,
      });
      data.colorCombin.SpcfctList[params.index] = resSpcfct.data;

      const res = await api.post(
        `${url}/colorCombin/selectCombnVolList`,
        params
      );
      data.colorCombin.combnVolList[params.index] = res.data.filter(
        (item) => item.inputCombnVol != 0
      );
    } else if (params.clickType == "list" && params.ansRemarkCn== null && params.clickType !== "list-delete") {
      cmUtil.toast("답변 등록 전입니다.");
      return;
    } else if (params.clickType == "list-delete") {
      if (!(await cmUtil.confirm("요청하신 배합문의를 삭제합니다 문의 글은 다시 확인이 불가합니다 삭제하시겠습니까?"))) {
        return false;
      }
      const res = await api.post(
        `${url}/colorCombin/updateMyCombinMngYn`,
        params
      );
      if (res.resultCode == 200) {
        
          await cmUtil.alert(            
              "배합문의가 삭제되었습니다."
          );
          data.colorCombin.search.tabType = "my";
          searchCmd("search");

      }
    }
  }
  // 조색배합 검색 우측 버튼
  else if (cmd === "popover") {
    data.popover = !data.popover;
  }
  // 조색배합 답변 > 색상배합 조회
  else if (cmd === "colorSearch") {
    //규격
    const resSpcfct = await api.post(`${url}/colorCombin/selectBox03`, {
      pntSn: params.pntSn,
    });
    data.colorCombin.SpcfctList[params.index] = resSpcfct.data;

    const res = await api.post(`${url}/colorCombin/selectCombnVolList`, params);
    let list = res.data.filter((item) => item.inputCombnVol != 0);
    if (list && list.length > 0) {
      data.colorCombin.combnVolList[params.index] = list;
    }
  }
}




/**********************
 * 모바일 scroll 조회
 *********************/
const handleScroll = throttle(() => {
  if (
    data.page.deviceType != "M" ||
    data.colorCombin.loading ||
    data.colorCombin.list.length === 0
  ) {
    return;
  }
  data.colorCombin.loading = true;
  const scrollPosition = window.innerHeight + window.scrollY;
  const bottom = document.documentElement.scrollHeight;

  

  if (scrollPosition >= bottom - 1250) {
    searchCmd("scrollSearch", { page: data.colorCombin.page + 1 });
  }
  data.colorCombin.loading = false;
}, 300);

onBeforeUnmount(() => {
  document.removeEventListener("scroll", handleScroll);
});

/*********************
 * 페이지 초기함
 *********************/
async function pageInit() {
  await dateCalculation("ALL");

  // 스크롤 이벤트 등록
  if (data.page.deviceType == "M") {
    document.addEventListener("scroll", handleScroll);
  }
}

/**********************
 * 등록일 버튼 모음
 *********************/
async function dateCalculation(period) {
  const today = new Date();
  let resultDate = new Date(today);

  switch (period) {
    case "ALL":
      break;
    case "1M":
      resultDate.setDate(today.getDate() - 29);
      break;
    case "6M":
      resultDate.setDate(today.getDate() - 179);
      break;
    case "1Y":
      resultDate.setDate(today.getDate() - 364);
      break;
    default:
      await cmUtil.alert("알 수 없는 기간입니다.");
      return null;
  }
}


/**********************
 * 조회 모음
 *********************/
async function searchCmd(cmd = "", params = {}) {
  //data.colorCombin.loading = true;
  

  if (cmd === "munsellSearch") {      
    if(data.colorCombin.search.searchKeyword == '' || data.colorCombin.search.searchKeyword == null ){
      cmUtil.toast("검색 키워드를 적어주세요.");
        return;
    }
    const res = await api.post(`${url}/colorCombin/selectMunsellCode`, {
      ...data.colorCombin.search,
      page: params["page"] || 1,
      limit: params["limit"] || data.colorCombin.limit,
    });
    if (params["page"] == null || params["page"] == 1) {
      paginationEl.value?.setCurrentPage(1);
    }

    data.colorCombin.list = res.data.list;
    data.colorCombin.page = params["page"] || 1;
    data.colorCombin.totalCount = res.data.totalCount;
    data.colorCombin.totalPage = data.colorCombin.totalCount
      ? Math.ceil(data.colorCombin.totalCount / data.colorCombin.limit)
      : 0;

    data.colorCombin.expendIndex = -1;
    if (data.route.combnCrcolnQstnSn > 0) {
      for (let i in res.data.list) {
        if (
          res.data.list[i].combnCrcolnQstnSn == data.route.combnCrcolnQstnSn
        ) {
          data.colorCombin.expendIndex = Number(i);
          break;
        }
      }
    }
  }
  // 모바일 조회
  else if (cmd === "scrollSearch") {
    const res = await api.post(`${url}/colorCombin/selectMunsellCode`, {
      ...data.colorCombin.search,
      page: params["page"] || 1,
      limit: params["limit"] || data.colorCombin.limit,
    });

    data.colorCombin.list.push(...res.data.list);
    data.colorCombin.page = params["page"] || 1;
    data.colorCombin.totalCount = res.data.totalCount;
    data.colorCombin.totalPage = data.colorCombin.totalCount
      ? Math.ceil(data.colorCombin.totalCount / data.colorCombin.limit)
      : 0;

    data.colorCombin.expendIndex = -1;
    await btnCmd("expendClick", { index: -1, clickType: "scrollSearch" });
  // data.colorCombin.loading = false;
  }
}


</script>

<style lang="scss" scoped>
.list_wrap {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  position: relative;
  &:deep(.chip_list) {
    box-sizing: border-box;
    width: 60.5px;
    float: left;
    margin: 0 1px 0 0;
    ul {
      box-sizing: border-box;
      width: 60.5px;
    }

    li {
      border-radius: 2px;
      &.is-active {
        a {
          box-sizing: border-box;
          border: 2px solid #ffffff;
          &::after {
            border: 1px solid #fff;
            width: 57.7px;
            height: 57.7px;
          }
        }
      }
      a {
        display: block;
        box-sizing: border-box;
        width: 60.5px;
        height: 60.5px;
        margin: 0 0 1px 0;
        padding: 0;
        &:hover {
          box-sizing: border-box;
          border: 2px solid #ffffff;
          &::after {
            border: 1px solid #fff;
            width: 57.7px;
            height: 57.7px;
          }
        }
      }
    }
  }
}
</style>
